var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageSelector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.8417 19.8864V23.8637H31.819V26.5152H27.8417V30.4924H25.1902V26.5152H21.2129V23.8637H25.1902V19.8864H27.8417ZM27.8523 3.97729C28.5789 3.97729 29.1675 4.56726 29.1675 5.29377V17.2349H26.516V6.62881H5.30386V25.1881L18.5614 11.9318L22.5387 15.9091V19.6597L18.5614 15.6824L9.05178 25.1894H18.5614V27.8409H3.9675C3.61857 27.8406 3.28406 27.7017 3.03746 27.4549C2.79086 27.208 2.65234 26.8734 2.65234 26.5245V5.29377C2.65477 4.9456 2.79407 4.61236 3.04014 4.36603C3.28622 4.11971 3.61933 3.98007 3.9675 3.97729H27.8523ZM10.6069 9.28032C11.3101 9.28032 11.9845 9.55968 12.4818 10.0569C12.979 10.5542 13.2584 11.2286 13.2584 11.9318C13.2584 12.6351 12.979 13.3095 12.4818 13.8067C11.9845 14.304 11.3101 14.5834 10.6069 14.5834C9.90366 14.5834 9.22924 14.304 8.73198 13.8067C8.23473 13.3095 7.95537 12.6351 7.95537 11.9318C7.95537 11.2286 8.23473 10.5542 8.73198 10.0569C9.22924 9.55968 9.90366 9.28032 10.6069 9.28032Z",
    fill: "#09121F",
    fillOpacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSelector);
export default __webpack_public_path__ + "static/media/Image_selector.5fd8767a9a94378bf05065539249ac53.svg";
export { ForwardRef as ReactComponent };